import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../PageHeader/PageHeader';
import { Box } from 'rizzui';
import AppButton from '../../components/AppButton/AppButton';
import AppInput from '../../components/AppInput/AppInput';
import AppSelect from '../../components/AppSelect/AppSelect';
import AppSwitch from '../../components/Switch/AppSwitch';
import { searchServices, domainId, addAdvertisement, updateAdvertisement, searchAdvertisement, searchParent } from '../../constant/Constant';
import { HitApi } from '../../Api/ApiHit';
import { setApiJson, setApiErrorJson } from '../../redux/Actions/ApiAction';
import { AdvertisementValidation } from '../../validationscheema/AddvertiesmentValidation';
import { getErrorMsg, hasError } from '../../utils/utils';
import FileuploadComp from '../../components/SingleFileUpload/FileuploadComp';
import SearchableSelect from '../../components/AppSelect/SearchableSelect';
import { getSelectedUnit } from '../../storage/Storage';
import toast from 'react-hot-toast';

function AddAdvertisement() {
    const ApiReducer = useSelector((state) => state.ApiReducer);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isEditMode, setIsEditMode] = useState(false);
    const [serviceOptions, setServiceOptions] = useState([]);
    const [parentSearch, setParentSearch] = useState();

    const url = window.location.pathname;
    const urlId = url.split('/')[3];

    useEffect(() => {
        const initialData = {
            description: "",
            parentId: "",
            discount: "",
            img: "",
            isActive: false,
        };

        if (urlId) {
            setIsEditMode(true);
            loadData();
        } else {
            dispatch(setApiJson(initialData));
            dispatch(setApiErrorJson({}));
        }

        getServices();
    }, [dispatch, urlId, parentSearch]);

    const handleSubmit = () => {
        const formData = {
            ...ApiReducer.apiJson,
            isActive: Boolean(ApiReducer.apiJson.isActive),
            unitIds: getSelectedUnit()?._id
        };

        AdvertisementValidation(formData).then((errors) => {
            dispatch(setApiErrorJson(errors));

            if (Object.keys(errors).length === 0) {
                if (isEditMode) {
                    // Add the ID for update
                    const updateData = {
                        ...formData,
                        _id: urlId
                    };
                    
                    HitApi(updateData, updateAdvertisement).then((res) => {
                        console.log("Update response:", res);
                        if (res?.message === "Advertisement updated successfully") {
                            toast.success("Advertisement updated successfully!");
                            navigate('/advertisement');
                        } else {
                            toast.error("Failed to update advertisement");
                        }
                    }).catch((error) => {
                        console.error("Update error:", error);
                        toast.error("An error occurred while updating");
                    });
                } else {
                    HitApi(formData, addAdvertisement).then((res) => {
                        console.log("Create response:", res);
                        if (res?.message === "Advertisement created successfully") {
                            toast.success("Advertisement created successfully!");
                            navigate('/advertisement');
                        } else {
                            toast.error("Failed to create advertisement");
                        }
                    }).catch((error) => {
                        console.error("Create error:", error);
                        toast.error("An error occurred while creating");
                    });
                }
            }
        });
    };

    const getServices = () => {
        let json = {
            page: 1,
            limit: 100,
            search: {
                name: parentSearch
            
            }
        };

        HitApi(json, searchParent).then((res) => {
            console.log("services response", res);
            if (res?.message === "Service items retrieved successfully" && Array.isArray(res?.data)) {
                const options = res.data.map(service => ({
                    value: service._id,
                    label: service.name
                }));
                setServiceOptions(options);
            }
        }).catch((error) => {
            console.error("Services fetch error:", error);
            toast.error("Failed to load services");
        });
    };

    const loadData = () => {
        var json = {
            page: 1,
            limit: 10,
            search: {
                _id: urlId
            }
        };

        HitApi(json, searchAdvertisement).then((res) => {
            console.log("advertisement result", res);
            if (res?.message === "Advertisement collection retrieved successfully") {
                const adData = res?.data?.[0];
                if (adData) {
                    // Extract the parentId from the nested object structure
                    const processedData = {
                        description: adData.description || "",
                        parentId: adData.parentId?._id || "", // Extract _id from parentId object
                        discount: adData.discount || "",
                        img: adData.img || "",
                        isActive: Boolean(adData.isActive),
                        // Store original data for reference if needed
                        _originalData: adData
                    };
                    
                    console.log("Processed data for edit:", processedData);
                    dispatch(setApiJson(processedData));
                    dispatch(setApiErrorJson({})); // Clear any existing errors
                }
            } else {
                toast.error("Failed to load advertisement data");
            }
        }).catch((error) => {
            console.error("Load data error:", error);
            toast.error("An error occurred while loading data");
        });
    };

    console.log("ApiReducer", ApiReducer);

    return (
        <div className="p-5">
            <PageHeader
                title={isEditMode ? 'Edit Advertisement' : 'Add New Advertisement'}
                description={isEditMode ? 'Update Your Advertisement Details' : 'Create a New Advertisement Campaign'}
            />
            <Box className="bg-white p-8 border rounded-xl mb-6">
                <div>
                    <div className="text-lg font-medium mb-5 flex justify-between items-center">
                        <span>Advertisement Details</span>
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
                    <AppInput
                        title="Discount %"
                        placeholder="Enter discount %"
                        name="discount"
                        important={true}
                        error={hasError('discount', ApiReducer)}
                        errormsg={getErrorMsg('discount', ApiReducer)}
                    />
                    <SearchableSelect
                        title="Select Service"
                        name="parentId"
                        options={serviceOptions}
                        placeholder="Select Service Group"
                        searchSlelect={parentSearch}
                        error={hasError('parentId', ApiReducer)}
                        errormsg={getErrorMsg('parentId', ApiReducer)}
                    />
                    <div className='flex items-center'>
                        <AppSwitch
                            title="Is Active"
                            name="isActive"
                            specification="Toggle to enable or disable this advertisement"
                            error={hasError('isActive', ApiReducer)}
                            errormsg={getErrorMsg('isActive', ApiReducer)}
                        />
                    </div>
                </div>
                <div>
                    <FileuploadComp
                        title="Image URL"
                        name="img"
                        allowed={["img"]}
                    />
                </div>

                <div className='mt-4'>
                    <AppInput
                        title="Description"
                        placeholder="Enter description"
                        name="description"
                        important={true}
                        error={hasError('description', ApiReducer)}
                        errormsg={getErrorMsg('description', ApiReducer)}
                    />
                </div>

                <div className='flex justify-end'>
                    <AppButton
                        buttontext={isEditMode ? "Update Advertisement" : "Create Advertisement"}
                        onClick={handleSubmit}
                    />
                </div>
            </Box>
        </div>
    );
}

export default AddAdvertisement;